import { IApplicationState } from '../../types/redux';

export const selectHasNextPage = (state: IApplicationState): boolean => {
  return state.hasNexPage;
};
